"use client"

import Link from 'next/link'
import { Button } from './ui/button'
import SignOutForm from './sign-out-form'
import Logo from './logo'
import { useUser } from '@/context/UserContext'
import { nav } from '@/content/landing'

export default function Navbar() {
  const user = useUser()
  return (
    <header className="sticky top-0 z-100 flex justify-center py-2">
      <div className="container border rounded-md w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 py-2 px-4">
        <nav className="flex items-center justify-between gap-4 sm:gap-6">
          <Logo />
          <div className="flex items-center gap-2">
            {user ? (
              <>
                <Button variant="outline" asChild>
                  <Link href="/home">{nav.monEspace}</Link>
                </Button>
                <SignOutForm />
              </>
            ) : (
              <>
                <Button variant="ghost" asChild>
                  <Link href="/sign-in">{nav.seConnecter}</Link>
                </Button>
                <Button asChild>
                  <Link href="/sign-up">{nav.creerCompte}</Link>
                </Button>
              </>
            )}
          </div>
        </nav>
      </div>
    </header>
  )
}
